/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnreadFaxCountResponse
 */
export interface UnreadFaxCountResponse {
    /**
     * Number of unread faxes in the given scope
     */
    count: number;
}

/**
 * Check if a given object implements the UnreadFaxCountResponse interface.
 */
export function instanceOfUnreadFaxCountResponse(value: object): value is UnreadFaxCountResponse {
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function UnreadFaxCountResponseFromJSON(json: any): UnreadFaxCountResponse {
    return UnreadFaxCountResponseFromJSONTyped(json, false);
}

export function UnreadFaxCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnreadFaxCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function UnreadFaxCountResponseToJSON(json: any): UnreadFaxCountResponse {
    return UnreadFaxCountResponseToJSONTyped(json, false);
}

export function UnreadFaxCountResponseToJSONTyped(value?: UnreadFaxCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

